import { render, staticRenderFns } from "./HelpDeskModal.vue?vue&type=template&id=21eef6ab&scoped=true"
import script from "./HelpDeskModal.vue?vue&type=script&lang=js"
export * from "./HelpDeskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eef6ab",
  null
  
)

export default component.exports